:host {
  @include cms-components-host-defaults;  
  color: var(--cms-theme-text-color);
}

.cms-collapsible-inner {
  --cms-grid-gap: 0;
  @include cms-default-grid-container;
}

.cms-collapsible-inner>* {
  grid-area: var(--cms-default-grid-area);
}

:host a {
  @include cms-anchor-base-font;
  color: var(--cms-theme-text-color);
}

.visible-text p {
  margin-bottom: 0;
}
.visible-text {
  grid-row-start: 1;
}
.hidden-text {
  grid-row-start: 2;
  height: 0;
  visibility: hidden;
  overflow: hidden;
  transition: height 0.3s ease-out;
  will-change: transform;

  cms-headline:is(:first-child) {
    padding-top: var(--cms-spacing-050);
  }

  p {
    margin-bottom: var(--cms-spacing-075);
    margin-top: 0;
  }
}

.button-wrapper {
  grid-area: var(--cms-default-grid-area);
  grid-row-start: 3;
}

cms-button {
  margin-top: var(--cms-spacing-100);
  width: var(--cms-container-width);
}
@include media-width($breakpoint-sm) {
  .button-wrapper {
    --cms-default-grid-area: auto / 4 / auto / span 6;
  }
}